import React from "react";
// css comes in create_hw_finle.css

const AttachmentAssessment = ({ attachment }) => {
  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };
  return (
    <>
      <div className=" hw_defult_attach_box">
        <img
          className=" hw_defult_attach_type_icon"
          src="/images/Pdf_logo.png"
          alt="icon"
        />
        <div className="hw_default_attach_name">
          <span>{"  "}{attachformat(attachment)}</span>
        </div>
      </div>
    </>
  );
};

export default AttachmentAssessment;
